import React, { useState } from "react";
import "../../css/ValueAddedProgrammes.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const PROGRAMS = [
  {
    icon: "🧩",
    title: "Functional Classrooms",
    desc: "Project-based learning gives students hands-on experience, encouraging collaboration, cooperation and research — while building conflict management and presentation skills along the way.",
  },
  {
    icon: "🧮",
    title: "Project & Activity Based Learning",
    desc: "Interactive learning tools help students build a genuine understanding of subjects like Mathematics, moving past rote memorisation toward real practice and self-paced learning.",
  },
  {
    icon: "📖",
    title: "Reading Programme",
    desc: "A structured reading programme ensures every student completes a set number of books each year, paired with related tasks that build comprehension and expression.",
  },
  {
    icon: "🤖",
    title: "STEAM-Based Learning & Robotics",
    desc: "A dedicated focus on Science, Technology, Engineering, Arts and Mathematics fosters logical thinking, with robotics and model-making bringing concepts to life through real-world problems.",
  },
  {
    icon: "💻",
    title: "Integrated Technology in Learning",
    desc: "Technology is woven into everyday learning through software labs, virtual classes with expert educators, and platforms that support self-paced learning.",
  },
  {
    icon: "🌐",
    title: "Global Student Exchange",
    desc: "Students collaborate with peers from other schools on shared projects, presenting their findings through video calls — building research, communication and cross-cultural skills.",
  },
  {
    icon: "🎯",
    title: "Individual Development Plan",
    desc: "Senior students set personal goals in consultation with parents and teachers, working out an action plan and taking ownership of their own progress with school support.",
  },
  {
    icon: "📊",
    title: "In-Depth Assessment Framework",
    desc: "A structured evaluation approach tracks a student's progress across multiple areas of learning, paired with topic-wise assessments that help identify learning gaps early.",
  },
];

const CLUBS = [
  { icon: "🧠", name: "Quiz Club", tag: "General knowledge" },
  { icon: "🎨", name: "Art Club", tag: "Art activities" },
  { icon: "📗", name: "Reading Club", tag: "Speaking skills" },
  { icon: "🎭", name: "Story Enactment Club", tag: "Dramatics" },
  { icon: "🎪", name: "Theatre Club", tag: "Dramatics" },
  { icon: "🖥️", name: "Digital Art Club", tag: "Art on computers" },
  { icon: "🏛️", name: "Heritage Club", tag: "Social science" },
  { icon: "🚀", name: "Start-up Club", tag: "Entrepreneurial skills" },
];

const FAQ_ITEMS = [
  {
    q: "What are Value Added Programmes at Sahara Public School?",
    a: "These are specialised, non-curriculum programmes — like STEAM, reading initiatives, and global exchanges — designed to help students grow into balanced, capable, and innovative individuals.",
  },
  {
    q: "Does the school use technology to support learning?",
    a: "Yes, we integrate software labs, virtual classes with experts, and digital learning platforms into everyday academics to enhance the learning experience.",
  },
  {
    q: "How does the school track individual student progress?",
    a: "Through tools like Individual Development Plans and structured assessment frameworks, we help students set goals and track their growth across multiple areas of learning.",
  },
];

export default function ValueAddedProgrammes() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="vap-page">
      {}
      <SchoolHero
        title="Value-Added Programmes"
        subtitle="World-Class Infrastructure"
        image="/images/ss.jpeg"
      />
      <section className="vap-hero">
        <h1>Value-Added Programmes</h1>
        <p>
          Rather than sticking to a strict curriculum, our educators design
          value-added programmes that prepare students to be happy, balanced,
          productive and innovative citizens of tomorrow.
        </p>
      </section>

      {}
      <section className="wrap vap-programs">
        {PROGRAMS.map((p, idx) => (
          <div
            className={`vap-program ${idx % 2 === 1 ? "reverse" : ""}`}
            key={p.title}
          >
            <div className="vap-program-icon">
              <span className="emoji-badge">{p.icon}</span>
            </div>
            <div>
              <h2>{p.title}</h2>
              <p>{p.desc}</p>
            </div>
          </div>
        ))}
      </section>

      {}
      <section className="vap-clubs-section">
        <div className="wrap">
          <h2>Skill-Based Clubs</h2>
          <p>
            A wide range of skill-based clubs help students discover hidden
            talents, build confidence, and open their minds to new possibilities
            beyond the classroom.
          </p>
          <div className="vap-clubs-grid">
            {CLUBS.map((c) => (
              <div className="vap-club-card" key={c.name}>
                <div className="vap-club-icon">{c.icon}</div>
                <div className="vap-club-name">{c.name}</div>
                <div className="vap-club-tag">{c.tag}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap vap-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
